
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke":"currentColor","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M37.11 29.326c2.285-4.447 3.543-9.193 4.058-14.146.124-1.194.179-2.396.266-3.598C34.138 9.563 27.869 5.84 22.2 1c-.094.072-.17.124-.24.184-5.506 4.683-11.6 8.302-18.603 10.27-.291.082-.367.223-.357.521.136 3.747.68 7.429 1.76 11.022 2.772 9.218 8.294 16.166 16.984 20.474.229.113.6.151.816.045 4.507-2.209 7.263-4.192 10.23-7.983"}}),_c('path',{attrs:{"stroke-linejoin":"round","d":"M13 22.347l6.871 6.976L33 16"}})])])
          )
        }
      }
    